import React, { createContext, useContext, useState, useEffect } from 'react';
import api from '../api/client';

const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('qserve_token');
    if (!token) {
      setLoading(false);
      return;
    }
    // Set from localStorage immediately for fast initial render
    const stored = localStorage.getItem('qserve_user');
    if (stored) {
      try { setUser(JSON.parse(stored)); } catch { /* ignore */ }
    }
    // Always refresh from server to get up-to-date status (docStatus, balance, etc.)
    api.auth.me()
      .then(data => {
        localStorage.setItem('qserve_user', JSON.stringify(data.user));
        setUser(data.user);
      })
      .catch(() => {
        localStorage.removeItem('qserve_token');
        localStorage.removeItem('qserve_user');
        setUser(null);
      })
      .finally(() => setLoading(false));
  }, []);

  const login = async (email, password) => {
    const data = await api.auth.login(email, password);
    localStorage.setItem('qserve_token', data.token);
    localStorage.setItem('qserve_user', JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const register = async (payload) => {
    const data = await api.auth.register(payload);
    localStorage.setItem('qserve_token', data.token);
    localStorage.setItem('qserve_user', JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const loginWithGoogleSession = async (session) => {
    const data = await api.auth.googleSession(session);
    localStorage.setItem('qserve_token', data.token);
    localStorage.setItem('qserve_user', JSON.stringify(data.user));
    setUser(data.user);
    return data;
  };

  const logout = () => {
    localStorage.removeItem('qserve_token');
    localStorage.removeItem('qserve_user');
    setUser(null);
  };

  const refreshUser = async () => {
    try {
      const data = await api.auth.me();
      localStorage.setItem('qserve_user', JSON.stringify(data.user));
      setUser(data.user);
    } catch {
      logout();
    }
  };

  return (
    <AuthContext.Provider value={{ user, loading, login, register, loginWithGoogleSession, logout, refreshUser }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
